
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SunsetAPIContext } from "../../Networking/ApiProvider";
import { UserContext } from "../../User/UserContext";

/**
 * Inline label used in the navbar dropdown.
 * The actual logout logic is handled by LogoutPage (mounted on /logout).
 */
export default function Logout(): React.ReactElement {
  return (
    <span className="logout-button">
      Logout
    </span>
  );
}

/**
 * Full-page component mounted at /logout.
 * Calls the C# logout endpoint, clears user state, then redirects to /login.
 */
export const LogoutPage: React.FC = () => {
  const api = useContext(SunsetAPIContext);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      try {
        await api?.logout();
      } catch {
        // swallow – we're logging out regardless
      }
      setUser(undefined);
      navigate("/login", { replace: true });
    };

    doLogout();
  }, [api, setUser, navigate]);

  return null;
};
